
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/promo/[code]",
      function () {
        return require("private-next-pages/promo/[code].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/promo/[code]"])
      });
    }
  